// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__EZRjR","content":"RecentSearches_content__uiDx4"};